/**
 * 我的订阅：接口返回的 class_name（固定中文）→ 各语言展示文案
 * i18n 键使用 ASCII slug（mySubscribe.serviceGroupClass.{slug}），避免路径中含中文的解析问题
 * 图标仍用原 class_name 查 ServiceGroupIcon
 */
import type { SubscribePriceTitleLocale } from './subscribe-price-title.messages'

/** 接口 class_name → mySubscribe.serviceGroupClass 下的键名 */
export const subscribeServiceGroupClassNameToSlug: Record<string, string> = {
  效率工具服务: 'productivityTools',
  终端运维服务: 'terminalOm',
  上网管控服务: 'internetControl',
  办公效率服务: 'officeEfficiency',
  终端安全服务: 'terminalSecurity',
  资产管理服务: 'assetManagement',
  数据安全服务: 'dataSecurity',
  终端优化服务: 'terminalOptimization',
}

export const subscribeServiceGroupClassMessages: Record<SubscribePriceTitleLocale, Record<string, string>> = {
  'zh-CN': {
    productivityTools: '效率工具服务',
    terminalOm: '终端运维服务',
    internetControl: '上网管控服务',
    officeEfficiency: '办公效率服务',
    terminalSecurity: '终端安全服务',
    assetManagement: '资产管理服务',
    dataSecurity: '数据安全服务',
    terminalOptimization: '终端优化服务',
  },
  'en-US': {
    productivityTools: 'Productivity tools services',
    terminalOm: 'Endpoint O&M services',
    internetControl: 'Internet access control services',
    officeEfficiency: 'Office productivity services',
    terminalSecurity: 'Endpoint security services',
    assetManagement: 'Asset management services',
    dataSecurity: 'Data security services',
    terminalOptimization: 'Endpoint optimization services',
  },
  'ja-JP': {
    productivityTools: '業務効率化ツール',
    terminalOm: '端末運用サービス',
    internetControl: 'インターネットアクセス制御サービス',
    officeEfficiency: 'オフィス生産性サービス',
    terminalSecurity: '端末セキュリティサービス',
    assetManagement: '資産管理サービス',
    dataSecurity: 'データセキュリティサービス',
    terminalOptimization: '端末最適化サービス',
  },
  'zh-TW': {
    productivityTools: '效率工具服務',
    terminalOm: '終端維運服務',
    internetControl: '上網管控服務',
    officeEfficiency: '辦公效率服務',
    terminalSecurity: '終端安全服務',
    assetManagement: '資產管理服務',
    dataSecurity: '資料安全服務',
    terminalOptimization: '終端最佳化服務',
  },
}
